import 'es6-promise/auto'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import 'vue-awesome/icons'
import SmoothScroll from 'vue-smoothscroll'
import Icon from 'vue-awesome/components/Icon'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import amplitude from 'amplitude-js'
import App from './App'
import store from './store'
import router from './router'
import i18n from './locales'
import { EventBus } from './utils/event-bus'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://dffc5a2cc1b04a66a9046b5dee53a640@sentry.io/1526540',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    release: process.env.VUE_APP_COMMIT
  })

  amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_KEY)
}

Vue.component('icon', Icon)
Vue.use(SmoothScroll)

require('es6-object-assign').polyfill()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: {
    App,
    Icon
  }
})
